import React, { useState } from "react";
import { useFormContext } from "react-hook-form";
import { Tooltip } from "reactstrap";
import GenerativeAnalysisFields from "./GenerativeAnalysisFields";
import LibraryMatchingFields from "./LibraryMatchingFields"; // import adicionado

function StepAnalysisConfig({ back }) {
  const {
    register,
    watch,
    setValue,
    formState: { errors, isSubmitted },
  } = useFormContext();
  const analysisType = watch("analysis_type");
  const isCopy = watch("IsCopy");

  const [copyWarningTooltipOpen, setCopyWarningTooltipOpen] = useState(false);

  const toggleCopyWarningTooltip = () =>
    setCopyWarningTooltipOpen((prev) => !prev);

  return (
    <div className="card bg-secondary shadow">
      <div className="card-header bg-white border-0">
        <div className="row align-items-center">
          <div className="col-8">
            <h3 className="mb-0">
              Configuração da análise
              {isCopy && (
                <i
                  className="fas fa-exclamation-triangle text-warning ml-2"
                  id="copyWarningAnalysisConfig"
                  style={{ cursor: "pointer" }}
                />
              )}
              {isCopy && (
                <Tooltip
                  placement="right"
                  isOpen={copyWarningTooltipOpen}
                  target="copyWarningAnalysisConfig"
                  toggle={toggleCopyWarningTooltip}
                >
                  <div>
                    <strong>⚠️ Cópia de Pipeline</strong>
                    <br />
                    Esta é uma cópia - confirme se{" "}
                    {analysisType === "generative"
                      ? "os prompts selecionados"
                      : "as bibliotecas escolhidas"}
                    <br />
                    atendem às suas necessidades antes de finalizar.
                  </div>
                </Tooltip>
              )}
            </h3>
          </div>
        </div>
      </div>
      <div className="card-body">
        <>
          <div className="mb-3">
            <label className="form-control-label">Título da Pipeline</label>
            <input
              type="text"
              className="form-control"
              {...register("title")}
            />
            {isSubmitted && errors.title && (
              <small className="text-danger" style={{ fontSize: "0.85em" }}>
                {errors.title.message}
              </small>
            )}
          </div>
          <div className="mb-3">
            <label className="form-control-label">Descrição da Pipeline</label>
            <textarea
              className="form-control"
              rows={2}
              {...register("description")}
            />
          </div>
          {analysisType === "generative" && (
            <GenerativeAnalysisFields
              back={back}
              errors={errors}
              isSubmitted={isSubmitted}
            />
          )}
          {analysisType === "library-matching" && (
            <LibraryMatchingFields
              back={back}
              errors={errors}
              isSubmitted={isSubmitted}
            />
          )}
          <div className="d-flex justify-content-between">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => {
                setValue("prompts", []);
                setValue("segment", null);
                setValue("libraries", []);
                setValue("libraryConfigurations", {});
                back();
              }}
            >
              Voltar
            </button>
            <button type="submit" className="btn btn-success">
              Salvar pipeline
            </button>
          </div>
        </>
      </div>
    </div>
  );
}

export default StepAnalysisConfig;
